import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { logoutSession } from '~/services/sessions/SessionsService';
import { useTokenStore } from '~/stores/token/useTokenStore';

function Logoff() {
  const navigate = useNavigate();

  useEffect(() => {
    const refresh = useTokenStore.getRefresh();

    const doLogout = async () => {
      if (refresh) {
        try {
          await logoutSession(refresh);
        } catch {
          // best-effort
        }
      }
      useTokenStore.clearAll();
      navigate('/', { replace: true });
    };

    void doLogout();
  }, [navigate]);

  return null;
}

export default Logoff;
